{[ if (o.allow_chat_pending_contacts)  { ]}
<a class="open-chat w-100" href="#">
{[ } ]}
<span class="pending-contact-name w-100" title="JID: {{{o.jid}}}">{{{o.display_name}}}</span> 
{[ if (o.allow_chat_pending_contacts)  { ]}</a>
{[ } ]}
<a class="remove-xmpp-contact far fa-trash-alt" title="{{{o.desc_remove}}}" href="#"></a>
